import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css';
import './colors.css';
import './rtl.css'; // RTL CSS support
import GlobalFont from './GlobalFont';
import './i18n'; 

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GlobalFont />
    <App />
  </React.StrictMode>,
)